// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"532":"styles","678":"component---src-pages-index-js","883":"component---src-pages-404-js"}[chunkId] + "-" + {"532":"c10f8c73d462e3c0a4d2","678":"51a0858479c1451fa3e6","883":"cf9aeac5ad58b1579433"}[chunkId] + ".js";
};